import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useGet } from "../../customHooks/useGet";
import { useAuthProvider } from "../../customHooks/authContext";
import { Container, Table, Alert, Button, Dropdown, DropdownButton, Form,Row, Col  } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight,FaMoneyBillAlt, FaPercent, FaCreditCard, FaBalanceScale, FaDivide  } from "react-icons/fa"; 
import "bootstrap/dist/css/bootstrap.min.css";
import { get,post  } from "../../services/Services";
import { Card } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";

const ManagementPayments = () => {
  const location = useLocation();
  const { eventRegistrationId, configId, school } = location.state || {};
  const { token } = useAuthProvider();
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(100);
  const [showHelpMessage, setShowHelpMessage] = useState(true);
  const [coursesData, setCoursesData] = useState(null);
  const [showPartialModal, setShowPartialModal] = useState(false);
  const [partialAmount, setPartialAmount] = useState("");
  const [paymentConditions, setPaymentConditions] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [manualAmount, setManualAmount] = useState('');
  const [selectedConditionId, setSelectedConditionId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(); // default es normal
  const [partialAmountInput, setPartialAmountInput] = useState('');
  const [pagosRealizados, setPagosRealizados] = useState([]);
  const [applyDiscount, setApplyDiscount] = useState(false);
  const [showInterestCheckbox, setShowInterestCheckbox] = useState(false);
  const [calcBase, setCalcBase] = useState('');
const [calcType, setCalcType] = useState(''); // 'descuento' o 'interes'
const [calcResult, setCalcResult] = useState(null);
  const [isSubtracted, setIsSubtracted] = useState(false);
  const { data: performancesData, refetch } = useGet(
    eventRegistrationId
         ? `https://ectech-software.com.ar/api/academy/events/registration/${eventRegistrationId}/performance?page=${page}&size=${size}`
         : null,
         { headers: { Authorization: `Bearer ${token}` } }
        );
  const totalPages = performancesData?.totalPages || 1;

  const { data: paymentConditionsData } = useGet(
    configId 
    ? `https://ectech-software.com.ar/api/academy/events/${configId}/payment-condition/all`
      : null,
      { headers: { Authorization: `Bearer ${token}` } }
  );

  useEffect(() => {
    if (paymentConditionsData) {
      setPaymentConditions(paymentConditionsData); // Ahora es un array
    }
  }, [paymentConditionsData]);


  const fetchPagosRealizados = async () => {
    try {
      const response = await get(`https://ectech-software.com.ar/api/academy/events/${configId}/financial-movements?event_registration_id=${eventRegistrationId}`);
      setPagosRealizados(response.data?.movements || []);
    } catch (error) {
      console.error("Error cargando pagos realizados:", error);
    }
  };

  useEffect(() => {
    if (configId && eventRegistrationId) {
      fetchPagosRealizados();
    }
  }, [configId, eventRegistrationId]);
  

  useEffect(() => {
  if (!configId || !eventRegistrationId) return;

  get(`https://ectech-software.com.ar/api/academy/events/${configId}/financial-movements?event_registration_id=${eventRegistrationId}`)
    .then((response) => {
      setPagosRealizados(response.data?.movements || []);
    })
    .catch((error) => console.error("Error cargando pagos realizados:", error));
}, [configId, eventRegistrationId]);

  
  
  
  
  // Separar obras becadas y no becadas
  const becadas = performancesData?.content?.filter(p => p.isScholarship) || [];
  const noBecadas = performancesData?.content?.filter(p => !p.isScholarship) || [];

  // Calcular totales
  const totalObras = noBecadas.reduce((acc, performance) => acc + (performance.totalPrice || 0), 0);
  const totalCursos = coursesData?.content?.reduce((acc, course) => acc + (course.totalPrice || 0), 0) || 0;
  const totalGeneral = totalObras + totalCursos;


 
  // Obtener cursos (seminarios)
  useEffect(() => {
    
    if (!eventRegistrationId) return;
    get(`/api/academy/events/registration/${eventRegistrationId}/courses?page=${page}&size=10`)
      .then((response) => setCoursesData(response.data))
      .catch((error) => console.error("Error loading courses:", error));
  }, [ configId, eventRegistrationId, page]);

  const handleRegisterPayment = async () => {
    try {
      if (selectedPaymentType === 'descuento') {
        const descuentoCondition = paymentConditionsData?.find(cond => cond.discountPercentage > 0);
        const discountPercentage = descuentoCondition ? descuentoCondition.discountPercentage : 0;
        const descuento = totalObras * discountPercentage / 100;
  
        // ✅ Ingreso normal
        await registrarMovimiento({
          movementType: "INGRESO",
          amount: partialAmount || 0,
          description: `Pago ${school}`,
          fecha: new Date(),
          eventRegistration: { id: eventRegistrationId },
        });
  
        // ✅ Egreso por descuento
        await registrarMovimiento({
          movementType: "DESCUENTO",
          amount: descuento,
          description: `Descuento aplicado a ${school}`,
          fecha: new Date(),
          eventRegistration: { id: eventRegistrationId },
        });
  
        toast.success("Pago registrado con éxito.");
        toast.success("Descuento registrado con éxito.");
  
      } else if (selectedPaymentType === 'normal') {
        // ✅ Pago normal
        await registrarMovimiento({
          movementType: "INGRESO",
          amount: partialAmount || 0,
          description: `Pago normal ${school}`,
          fecha: new Date(),
          eventRegistration: { id: eventRegistrationId },
        });
  
        toast.success("Pago Normal registrado con éxito.");
  
      } else if (selectedPaymentType === 'interes') {
        const interesCondition = paymentConditionsData?.find(cond => cond.interestPercentage > 0);
        const interestPercentage = interesCondition ? interesCondition.interestPercentage : 0;
        const interes = totalGeneral * interestPercentage / 100;
  
        // ✅ Ingreso por pago
        await registrarMovimiento({
          movementType: "INGRESO",
          amount: partialAmount || 0,
          description: 'Pago con interés',
          fecha: new Date(),
          eventRegistration: { id: eventRegistrationId },
        });
  
        // ✅ Ingreso por interés
        await registrarMovimiento({
          movementType: "INTERES",
          amount: interes,
          description: `Interés aplicado a ${school}`,
          fecha: new Date(),
          eventRegistration: { id: eventRegistrationId },
        });
  
        toast.success("Pago registrado con éxito.");
        toast.success("Interés registrado con éxito.");
  
      } else if (selectedPaymentType === 'parcial') {
        // ✅ Pago parcial
        await registrarMovimiento({
          movementType: "INGRESO",
          amount: partialAmount || 0,
          description: `Pago parcial ${school}`,
          fecha: new Date(),
          eventRegistration: { id: eventRegistrationId },
        });
           
        // ✅ Si aplica interés
        if (applyInterest) {
          const interesCondition = paymentConditionsData?.find(cond => cond.interestPercentage > 0);
          const interestPercentage = interesCondition ? interesCondition.interestPercentage : 0;
          const interes = partialAmount * interestPercentage / 100;
  
          await registrarMovimiento({
            movementType: "INTERES",
            amount: interes,
            description: `Interés aplicado a ${school}`,
            fecha: new Date(),
            eventRegistration: { id: eventRegistrationId },
          });
  
          toast.success("Pago registrado con éxito.");
        }
      }
  
      // ✅ Refrescar tabla después de todo
      await refetch();
      await fetchPagosRealizados();
      // ✅ Ahora sí, cerrar modal
      setShowPaymentModal(false);
  
    } catch (error) {
      toast.error("❌ Error registrando el pago.");
    }
  };
  
  const registrarMovimiento = async (movimiento) => {
    try {
      await post(`/api/academy/events/${configId}/financial-movements`, movimiento);
    } catch (error) {
      toast.error("❌ Error registrando el pago.");
    }
  };
 
  
  // Agregar estado para checkbox de interés
const [applyInterest, setApplyInterest] = useState(false);
const interestCondition = paymentConditionsData?.find(cond => cond.interestPercentage > 0);
const interestPercentagelbl = interestCondition ? interestCondition.interestPercentage : 0;
const [totales, setTotales] = useState({ obras: 0, cursos: 0, general: 0 });

useEffect(() => {
  if (performancesData?.content && coursesData?.content) {
    const noBecadasLocal = performancesData.content.filter(p => !p.isScholarship);
    const totalObrasLocal = noBecadasLocal.reduce((acc, p) => acc + (p.totalPrice || 0), 0);
    const totalCursosLocal = coursesData.content.reduce((acc, c) => acc + (c.totalPrice || 0), 0);
    const totalGeneralLocal = totalObrasLocal + totalCursosLocal;
    setTotales({ obras: totalObrasLocal, cursos: totalCursosLocal, general: totalGeneralLocal });
  }
}, [performancesData, coursesData]);



const calculatePendingBalance = () => {
  const paidAmount = pagosRealizados
    .filter(p => p.movementType === "INGRESO")
    .reduce((sum, p) => sum + p.amount, 0);

  const balance = parseFloat(totalGeneral) - paidAmount;
  console.log("El balance es", balance);
  return balance;
};



const calculateTotalPaid = () => {
  return pagosRealizados.reduce((sum, pago) => {
    switch (pago.movementType) {
      case 'INGRESO':
      case 'INTERES':
        return sum + pago.amount;
      case 'DESCUENTO':
        return sum - pago.amount;
      default:
        return sum; // Ignora otros tipos
    }
  }, 0);
};

const calcularMontoFinal = () => {
  if (selectedPaymentType === 'descuento') {
    const descuentoCondition = paymentConditionsData?.find(cond => cond.discountPercentage > 0);
    const discountPercentage = descuentoCondition ? descuentoCondition.discountPercentage : 0;
    const descuento = totalObras * discountPercentage / 100;
    return totalGeneral - descuento;

  } else if (selectedPaymentType === 'interes') {
    const interesCondition = paymentConditionsData?.find(cond => cond.interestPercentage > 0);
    const interestPercentage = interesCondition ? interesCondition.interestPercentage : 0;
    const interes = totalGeneral * interestPercentage / 100;
    return totalGeneral + interes;

  } else if (selectedPaymentType === 'parcial') {
    let monto = Number(partialAmount) || 0;
    if (applyInterest) {
      const interesCondition = paymentConditionsData?.find(cond => cond.interestPercentage > 0);
      const interestPercentage = interesCondition ? interesCondition.interestPercentage : 0;
      const interes = monto * interestPercentage / 100;
      return monto + interes;
    }
    return monto;

  } else {
    // pago normal
    return (Number(partialAmount) || 0);
  }
};
const handleCalculator = () => {
  const base = parseFloat(calcBase);
  if (isNaN(base) || !calcType) return;

  let finalAmount = base;
  const percentage = 0.2;

  if (calcType === 'descuento') {
    finalAmount = isSubtracted ? base * (1 - percentage) : base * (1 + percentage);
  } else if (calcType === 'interes') {
    finalAmount = isSubtracted ? base / (1 + percentage) : base * (1 + percentage);
  }

  setCalcResult(finalAmount);
};

  

 return (
    <Container className="mt-4 pb-5">
     <h2 className="text-center fw-bold">Detalle de pagos Obras y Seminarios de {school}</h2>

      {/* Tabla de Obras NO Becadas */}
      <h5 className="text-center mt-4">Obras</h5>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
  <Table striped bordered hover className="text-center" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
    <thead className="table-primary" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
      <tr>
        <th>Orden</th>
        <th>Nombre</th>
        <th>Categoría</th>
        <th>Modalidad</th>
        <th>Forma</th>
        <th>Precio</th>
      </tr>
    </thead>
    <tbody>
      {noBecadas
        .slice()
        .sort((a, b) => a.order - b.order)
        .map((performance, index) => (
          <tr key={`${performance.id}-${index}`}>
            <td className="fw-bold">{performance.order}</td>
            <td>{performance.name}</td>
            <td>{performance.category?.name || "N/A"}</td>
            <td>{performance.modality?.name || "N/A"}</td>
            <td>{performance.form?.name || "N/A"}</td>
            <td>$ {performance.totalPrice || "N/A"}</td>
          </tr>
      ))}
    </tbody>
    <tfoot style={{ position: 'sticky', bottom: 0, backgroundColor: '#e9ecef', zIndex: 1 }}>
      <tr className="fw-bold table-secondary">
        <td colSpan="5" className="text-end">Total Obras:</td>
        <td>{totalObras.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
      </tr>
    </tfoot>
  </Table>
</div>


      {/* Tabla de Obras Becadas */}
      {becadas.length > 0 && (
        <>
          <h5 className="text-center mt-4">Obras Becadas (no se incluyen en el total)</h5>
          <Table striped bordered hover className="text-center">
            <thead className="table-warning">
              <tr>
                <th>Orden</th>
                <th>Nombre</th>
                <th>Categoría</th>
                <th>Modalidad</th>
                <th>Forma</th>
                <th>Precio</th>
              </tr>
            </thead>
            <tbody>
              {becadas
                .slice()
                .sort((a, b) => a.order - b.order)
                .map((performance, index) => (
                  <tr key={`${performance.id}-${index}`}>
                    <td className="fw-bold">{performance.order}</td>
                    <td>{performance.name}</td>
                    <td>{performance.category?.name || "N/A"}</td>
                    <td>{performance.modality?.name || "N/A"}</td>
                    <td>{performance.form?.name || "N/A"}</td>
                    <td>$ {performance.totalPrice || "N/A"}</td>
                  </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}

      {/* Tabla de Seminarios / Congresos */}
      <h5 className="text-center mt-4">Seminarios / Congresos</h5>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
<Table striped bordered hover className="text-center">
<thead className="table-primary" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
    <tr>
      <th>Nombre del Seminario / Congreso</th>
      <th>Participantes</th>
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    {coursesData?.content?.map((curso) => (
      <tr key={curso.id}>
        <td>{curso.course?.name}</td>
        <td className="text-start">
          <ol className="mb-0">
          {curso.participants?.map((p, idx) => (
            <li key={idx}>
              {p.member?.name || ''} {p.member?.surname || ''}
            </li>
          ))}
          </ol>
        </td>
        <td>{curso.totalPrice?.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
      </tr>
    ))}
  </tbody>
  <tfoot style={{ position: 'sticky', bottom: 0, backgroundColor: '#e9ecef', zIndex: 1 }}>
    <tr className="fw-bold table-secondary">
      <td colSpan="2" className="text-end">Total Seminarios:</td>
      <td>{totalCursos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
    </tr>
  </tfoot>
</Table>
</div>

       {/* Total General sin ajustes */}
<h3 className="text-end fw-bold mt-3">
  Total General: {totales.general.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}
</h3>
<div className="my-5 d-flex flex-wrap justify-content-center gap-4">
<Button 
          variant="outline-primary" 
          className="mt-3 w-30 text-center"
          onClick={() => {
            if (paymentConditionsData) {
              setSelectedPaymentType('normal');
              setPartialAmount(totalGeneral || 0);
              setShowPaymentModal(true);
            } else {
              alert('Las condiciones de pago no están disponibles aún.');
            }
          }}>
          Registrar Pago
        </Button>
       
</div>
{/* Tabla de Pagos Realizados */}
{pagosRealizados.length > 0 && (
  <>
    <h5 className="text-center mt-4 text-primary">Pagos Realizados</h5>
    <Table striped bordered hover responsive className="text-center">
  <thead className="table-primary">
    <tr>
      <th>Fecha</th>
      <th>Descripción</th>
      <th>Monto</th>
    </tr>
  </thead>
  <tbody>
    {pagosRealizados.map((pago) => (
      <tr key={pago.id}>
        <td>{new Date(pago.date).toLocaleDateString('es-AR')}</td>
        <td>{pago.description}</td>
        <td className="text-center">{pago.amount.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
      </tr>
    ))}

 {/* Fila de Total pagado */}
<tr style={{ fontWeight: 'bold' }}>
  <td colSpan={2} className="text-end">Total pagado</td>
  <td className="text-center">
    {calculateTotalPaid().toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}
  </td>
</tr>

{/* Fila de Saldo pendiente */}
<tr
  style={{
    fontWeight: 'bold',
    fontSize: '1.25rem', // ajustá el valor a gusto
    backgroundColor: calculatePendingBalance() > 0 ? '#f8d7da' : '#d4edda'
  }}
>
  <td colSpan={2} className="text-end text-danger">Saldo pendiente</td>
  <td className="text-center text-danger">
    {calculatePendingBalance().toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}
  </td>
</tr>


  </tbody>
</Table>

  </>
)}

 
       


<Modal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Registrar Pago</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      {/* Selección de Tipo de Pago */}
      <Form.Group controlId="paymentType">
        <Form.Label>Tipo de Pago</Form.Label>
        <div className="d-flex flex-column">
          <Form.Check
            type="radio"
            label={<><FaMoneyBillAlt className="mr-2" /> Pago Normal por el Total</>}
            value="normal"
            checked={selectedPaymentType === 'normal'}
            onChange={() => {
              setSelectedPaymentType('normal');
              setSelectedCondition(null);
              setPartialAmount(totalGeneral);
              setShowInterestCheckbox(false);
              setApplyInterest(false);
            }}
            className="mb-2"
          />

          <Form.Check
            type="radio"
            label={<><FaPercent className="mr-2" /> Descuento por el Total</>}
            value="descuento"
            checked={selectedPaymentType === 'descuento'}
            onChange={() => {
              setSelectedPaymentType('descuento');
              setSelectedCondition(null);
              setPartialAmount(totalGeneral);
              setShowInterestCheckbox(false);
              setApplyInterest(false);
            }}
            className="mb-2"
          />

          <Form.Check
            type="radio"
            label={<><FaCreditCard className="mr-2" /> Monto con Interés por el total</>}
            value="interes"
            checked={selectedPaymentType === 'interes'}
            onChange={() => {
              setSelectedPaymentType('interes');
              const applicableCondition = paymentConditionsData?.find(
                (condition) => condition.interestPercentage > 0
              );
              setSelectedCondition(applicableCondition);
              setPartialAmount(totalGeneral);
              setShowInterestCheckbox(false);
              setApplyInterest(false);
            }}
            className="mb-2"
          />

          <Form.Check
            type="radio"
            label={<><FaDivide className="mr-2" /> Pago Parcial</>}
            value="parcial"
            checked={selectedPaymentType === 'parcial'}
            onChange={() => {
              setSelectedPaymentType('parcial');
              const applicableCondition = paymentConditionsData?.find(
                (condition) => condition.interestPercentage > 0
              );
              setSelectedCondition(applicableCondition);
              setPartialAmount(0);
              setShowInterestCheckbox(true);
              setApplyInterest(false);
            }}
            className="mb-2"
          />
        </div>
      </Form.Group>

      {/* Checkbox de interés si es pago parcial */}
      {showInterestCheckbox && selectedPaymentType === 'parcial' && (
        <Form.Group controlId="applyInterest">
          <Form.Check
            type="checkbox"
            label={`Aplicar interés (${selectedCondition?.interestPercentage || 0}%)`}
            checked={applyInterest}
            onChange={(e) => setApplyInterest(e.target.checked)}
            disabled={selectedCondition?.interestPercentage === 0}
            className="mb-3"
          />

          {/* Campo monto parcial */}
          <Form.Group controlId="partialAmount">
            <Form.Label>Monto Parcial</Form.Label>
            <Form.Control
              type="number"
              value={partialAmount > 0 ? partialAmount : ""}
              onChange={(e) =>
                setPartialAmount(e.target.value === "" ? "" : Number(e.target.value))
              }
              placeholder="Monto parcial"
              className="mb-3"
            />
          </Form.Group>
        </Form.Group>
      )}

      {/* Mostrar monto calculado final */}
      <Form.Group>
        <Form.Label><strong>Monto a pagar:</strong></Form.Label>
        <Form.Control
          type="text"
          value={calcularMontoFinal().toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}
          readOnly
          className="mb-3"
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowPaymentModal(false)}>
      Cerrar
    </Button>
    <Button variant="primary" onClick={handleRegisterPayment}>
      Registrar Pago
    </Button>
  </Modal.Footer>
</Modal>

<Row className="justify-content-center">
  <Col xs={10} md={6} lg={4}>
    <Card className="mt-4 p-3 shadow-sm">
      <h5>Calculadora de Pago Parcial</h5>

      <Form.Group className="mb-2">
        <Form.Label>Monto base</Form.Label>
        <Form.Control
          type="number"
          value={calcBase}
          onChange={(e) => setCalcBase(e.target.value)}
          placeholder="Ingrese un monto"
        />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label>Tipo</Form.Label>
        <Form.Select
          value={calcType}
          onChange={(e) => setCalcType(e.target.value)}
        >
          <option value="">Seleccionar</option>
          <option value="descuento">Descuento</option>
          <option value="interes">Interés</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-2">
  <Form.Check
    type="checkbox"
    label={calcType === 'descuento' ? 'Aplicar descuento (restar)' : 'Restar interés'}
    checked={isSubtracted}
    onChange={(e) => setIsSubtracted(e.target.checked)}
    disabled={!calcType}
  />
</Form.Group>

      <Button variant="primary" onClick={handleCalculator}>
        Calcular
      </Button>

      {calcResult !== null && (
        <Alert variant="info" className="mt-3">
          Monto Final:{" "}
          {calcResult.toLocaleString("es-AR", {
            style: "currency",
            currency: "ARS",
          })}
        </Alert>
      )}
    </Card>
  </Col>
</Row>


{/* ToastContainer */}
  <ToastContainer 
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  




</Container>

);

};
export default ManagementPayments;
